var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowBanner)?_c('Banner',{attrs:{"color-scheme":"alert","banner-message":_vm.bannerMessage,"action-button-label":_vm.actionButtonMessage,"action-button-icon":"mail","has-action-button":""},on:{"click":_vm.resendVerificationEmail}}):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }